<div class="mt-5">
  <h3 class="mat-h3">Center aliases</h3>
  <div>
    <div class="mb-2" *ngFor="let alias of aliasCenters">
      <p class="text-xs">{{ alias.c_id }}</p>
      <p class="text-slate-600">{{ alias.c_name }}</p>
    </div>
  </div>
</div>
